// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let ReactImageCrop = require("react-image-crop").default;
let ReactImageCrop$1 = require("react-image-crop");
let JsxRuntime = require("react/jsx-runtime");

function tToJs(crop) {
  return {
    unit: crop.unit,
    x: crop.x,
    y: crop.y,
    width: crop.width,
    height: crop.height
  };
}

function tFromJs(crop) {
  let match = crop.unit;
  let tmp = match === "px" ? "px" : "%";
  return {
    unit: tmp,
    x: crop.x,
    y: crop.y,
    width: crop.width,
    height: crop.height
  };
}

let Crop = {
  tToJs: tToJs,
  tFromJs: tFromJs
};

((require('react-image-crop/dist/ReactCrop.css')));

let Helpers = {};

function makeAspectCrop(crop, aspect, containerWidth, containerHeight) {
  return tFromJs(ReactImageCrop$1.makeAspectCrop(tToJs(crop), aspect, containerWidth, containerHeight));
}

function centerCrop(crop, containerWidth, containerHeight) {
  return tFromJs(ReactImageCrop$1.centerCrop(tToJs(crop), containerWidth, containerHeight));
}

let JS = {};

function ReactImageCrop$2(props) {
  let onComplete = props.onComplete;
  let onChange = props.onChange;
  return JsxRuntime.jsx(ReactImageCrop, {
    crop: Stdlib_Option.map(props.crop, tToJs),
    aspect: props.aspect,
    onChange: (px, pct) => onChange(tFromJs(px), tFromJs(pct)),
    onComplete: onComplete !== undefined ? (px, pct) => onComplete(tFromJs(px), tFromJs(pct)) : undefined,
    minWidth: props.minWidth,
    minHeight: props.minHeight,
    keepSelection: props.keepSelection,
    circularCrop: props.circularCrop,
    className: props.className,
    children: props.children
  });
}

let make = ReactImageCrop$2;

exports.Crop = Crop;
exports.Helpers = Helpers;
exports.makeAspectCrop = makeAspectCrop;
exports.centerCrop = centerCrop;
exports.JS = JS;
exports.make = make;
/*  Not a pure module */
